{
  "OPTIONAL": "Opcional",
  "BOOLEAN": {
    "YES": "Sim",
    "NO": "Não"
  },
  "URGENCY": {
    "HIGH": "Alto",
    "LOW": "Baixo"
  },
  "APP": {
    "VERSION": "Esta aplicação está a correr na versão {version}"
  },
  "BUTTONS": {
    "NEXT": "Seguinte",
    "SKIP": "Saltar",
    "CONFIRM": "Confirmar",
    "CLOSE": "Fechar",
    "CANCEL": "Cancelar",
    "SHOW_ALL": "Mostrar todas",
    "HIDE": "Ocultar"
  },
  "FOOTER": {
    "HOME": "Início",
    "WORK": "Trabalho",
    "TOOLBOXES": "Caixas de ferramentas",
    "PROFILE": "Perfil"
  },
  "WORK": {
    "EMPTY_STATE_TITLE": "Ainda não há projetos",
    "EMPTY_STATE_MESSAGE": "Os projetos aparecerão em breve."
  },
  "HOME": {
    "PRODUCT_NAME": "i-LOP",
    "PRODUCT_NAME_BETA": "BETA",
    "CHECK_IN_STATUS": {
      "CHECKED_IN": "Registado",
      "CHECKED_OUT": "Desregistado",
      "CHECK_IN": "Registar entrada",
      "CHECK_OUT": "Registar saída"
    },
    "TO_FULFILL": "Por cumprir",
    "CHECKLISTS": "Listas de verificação",
    "CERTIFICATES": "Certificados",
    "SAFETY_INSTRUCTIONS": "Instruções de Segurança",
    "TOOLBOXES": "Caixas de ferramentas",
    "NOT_ASSIGNED_TO_PROJECT": {
      "TITLE": "Sem projeto ativo",
      "MESSAGE": "Ainda não está registado num projeto. Encontre um projeto para começar!",
      "BUTTON": "Encontrar projeto"
    },
    "ALERTS": "Mensagens",
    "NO_ALERTS": "Atualmente não há mensagens",
    "CURRENT_CHECK_IN": "Atualmente registado",
    "LAST_PROJECT": "Último projeto",
    "CHECKED_IN_AT": "Registado às {time}",
    "LAST_CHECKED_IN": "Último registo às {time}",
    "CHECKED_OUT_AT": "Saída registada às {time}",
    "FOREMAN": {
      "WORKERS_ON_SITE": "Trabalhadores na obra",
      "START_WORK_INSTRUCTION": "Start Werk Instructie",
      "CREATE": "+ Criar"
    }
  },
  "SAFETY_INSTRUCTIONS": {
    "TITLE": "Instruções de Segurança",
    "ALL_COMPLETED": "Todas as instruções de segurança obrigatórias estão concluídas"
  },
  "SAFETY_INSTRUCTION": {
    "PREVIOUS": "Anterior",
    "NEXT": "Seguinte",
    "FINISH": "Concluir",
    "QUESTION_HINT_AT_LEAST_ONE": "Por favor, selecione pelo menos uma resposta correta",
    "QUESTION_HINT_ALL_CORRECT": "Por favor, selecione todas as respostas corretas",
    "QUESTION_ERROR_ALL_CORRECT": "Estas não são as respostas corretas, por favor tente novamente",
    "QUESTION_CORRECT": "Resposta correta!",
    "QUESTION_ERROR_UNANSWERED": "Por favor, forneça respostas corretas a todas as perguntas antes de continuar"
  },
  "LOGIN": {
    "EMAIL_LABEL": "Email",
    "PASSWORD_LABEL": "Palavra-passe",
    "EMAIL_PLACEHOLDER": "Introduza o seu endereço de email",
    "PASSWORD_PLACEHOLDER": "Introduza a sua palavra-passe",
    "LOGIN_BUTTON": "Entrar",
    "LOG_IN": "Entrar",
    "FORGOT_PASSWORD": "Esqueceu-se da palavra-passe?",
    "LOGIN_WITH_YIVI": "Entrar com Yivi",
    "YIVI_HELP": "Use Yivi para entrar ou criar a sua conta.",
    "PASSWORD_LOGIN": "Entrar com palavra-passe"
  },
  "FORGOT_PASSWORD": {
    "TITLE": "Palavra-passe esquecida",
    "DESCRIPTION": "Introduza o seu endereço de email para lhe enviarmos um email de recuperação de palavra-passe",
    "EMAIL_LABEL": "Email",
    "EMAIL_PLACEHOLDER": "Introduza o seu endereço de email",
    "SUCCESS_MESSAGE_1": "Enviámos um email de confirmação para",
    "SUCCESS_MESSAGE_2": "Verifique o seu email e clique no link de confirmação para continuar",
    "SUBMIT_BUTTON": "Submeter",
    "RESEND_BUTTON": "Reenviar email"
  },
  "RESET_PASSWORD": {
    "TITLE": "Redefinir palavra-passe",
    "DESCRIPTION": "Crie uma nova palavra-passe forte, que não use para outros websites",
    "PASSWORD_LABEL": "Nova palavra-passe",
    "PASSWORD_PLACEHOLDER": "Introduza a sua nova palavra-passe",
    "VERIFY_PASSWORD_LABEL": "Verificar nova palavra-passe",
    "VERIFY_PASSWORD_PLACEHOLDER": "Introduza novamente a sua nova palavra-passe",
    "PASSWORD_MISMATCH": "As palavras-passe não coincidem",
    "RESET_BUTTON": "Redefinir palavra-passe",
    "INVALID_TOKEN": "O endereço de email é inválido ou o token expirou. Por favor, solicite uma nova redefinição de palavra-passe",
    "SUCCESS_TITLE": "Sucesso!",
    "SUCCESS_MESSAGE": "A sua palavra-passe foi redefinida com sucesso. Já pode entrar com a sua nova palavra-passe.",
    "LOGIN": "Entrar",
    "INVALID_LINK_TITLE": "Link de redefinição inválido",
    "INVALID_LINK_MESSAGE": "Este link de redefinição de palavra-passe é inválido ou expirou. Por favor, solicite uma nova redefinição de palavra-passe.",
    "REQUEST_NEW_LINK": "Solicitar novo link de redefinição"
  },
  "ACCEPT_INVITATION": {
    "INTRO": {
      "TITLE": "Convite",
      "DESCRIPTION": "Foi convidado para um vínculo de trabalho. Reveja os detalhes e aceite para começar.",
      "SUBSCRIPT": "Este link de convite pode ser usado apenas uma vez e expira em 7 dias.",
      "BUTTON": "Aceitar convite"
    },
    "OFFER": {
      "ORGANISATION": "Organização",
      "FUNCTION": "Função",
      "START_DATE": "Data de início",
      "END_DATE": "Data de término",
      "INVITED_AS": "Convidado como"
    },
    "ACCEPT_ON_PHONE": {
      "TITLE": "Aceitar no telemóvel",
      "DESCRIPTION": "Digitalize este código com a câmara do telemóvel para abrir este convite na aplicação i-LOP."
    },
    "SIGN_IN_TO_ACCEPT": "Inicie sessão para aceitar",
    "SUCCESS": {
      "TITLE": "Convite aceite!",
      "DESCRIPTION": "O seu vínculo de trabalho está agora associado à sua conta.",
      "BUTTON": "Continuar"
    },
    "ALREADY_ACCEPTED": {
      "TITLE": "Já aceite",
      "DESCRIPTION": "Este convite já foi aceite."
    },
    "NOT_INVITABLE": {
      "TITLE": "Convite já não é válido",
      "DESCRIPTION": "Este vínculo laboral já não está disponível. Contacte o seu empregador."
    },
    "EXPIRED": {
      "TITLE": "Convite expirado",
      "DESCRIPTION": "Este link de convite expirou. Peça ao seu empregador para enviar um novo convite."
    },
    "INVALID_LINK": {
      "TITLE": "Link de convite inválido",
      "DESCRIPTION": "Este link de convite é inválido. Contacte o seu administrador para solicitar um novo convite."
    }
  },
  "ERRORS": {
    "AUTHENTICATION": {
      "USER_ALREADY_EXISTS": "Endereço de email já em uso",
      "INVALID": "O seu endereço de email ou palavra-passe está incorreto",
      "TRY_LATER": "Não pode entrar neste momento, tente novamente mais tarde",
      "TOKEN_NOT_VALID": "Precisa de entrar novamente",
      "YIVI_FAILED": "Ocorreu um erro ao entrar com Yivi"
    },
    "PROJECT_SELECT": {
      "ALREADY_ASSIGNED": "Já está atribuído a este projeto.",
      "NOT_ASSIGNED": "Não está atribuído a este projeto."
    },
    "QRCODE_SCANNER": {
      "NO_PERMISSION": "Sem permissão para usar a câmara",
      "INVALID": "O código QR é inválido",
      "EXPIRED": "O código QR expirou",
      "NO_PROJECT_SELECTED": "Escolha primeiro o projeto para o qual quer verificar",
      "NO_PROJECT_TO_VERIFY": "Não dirige nenhum projeto aqui, por isso não há projeto para verificar este trabalhador",
      "PROJECTS_UNAVAILABLE": "Não foi possível carregar os seus projetos. Verifique a ligação e digitalize novamente",
      "IDENTITY_NOT_RESOLVED": "O código QR não corresponde a uma única conta da aplicação"
    },
    "AVATAR": {
      "TOO_LARGE": "O ficheiro da fotografia é demasiado grande. Escolha uma fotografia mais pequena.",
      "DIMENSIONS_TOO_LARGE": "A fotografia é demasiado grande. Escolha uma fotografia mais pequena.",
      "UNSUPPORTED_IMAGE_TYPE": "Este tipo de ficheiro não pode ser utilizado como foto de perfil. Escolha uma imagem JPEG, PNG ou WebP.",
      "MALFORMED_IMAGE": "Não foi possível ler a fotografia. Tente outra fotografia.",
      "INVALID_IMAGE": "A fotografia não pode ser utilizada como foto de perfil."
    },
    "GENERIC": "Algo correu mal",
    "NETWORK": "Não é possível conectar ao servidor",
    "NOT_FOUND": "Não é possível encontrar algo",
    "UNKNOWN": "Ocorreu um erro desconhecido",
    "OFFLINE": "Não está online",
    "NOT_CHECKED_IN": "Não está registado num projeto",
    "CONTENT_OUTSTANDING": "Conclua todas as instruções e toolboxes antes de assinar.",
    "INVALID_SIGNATURE": "Não foi possível ler a assinatura. Desenhe-a novamente.",
    "NO_PROJECT_ACCESS": "Não tem acesso a este projeto",
    "NO_ACCESS": "Não tem permissão para isto",
    "INVITATION_INVALID": "O link de convite não é válido.",
    "INVITATION_EXPIRED": "O link de convite expirou. Peça ao seu empregador para enviar um novo.",
    "EMPLOYMENT_ALREADY_ACCEPTED": "Este vínculo de trabalho já está associado a outra conta.",
    "EMPLOYMENT_NOT_INVITABLE": "Este vínculo de trabalho já não pode ser aceite.",
    "PERSON_BINDING_CONFLICT": "Este registo de pessoa está associado a outra conta na aplicação. Contacte o seu administrador.",
    "GATE_ENTRY_REQUIRES_EXCEPTION": "Este trabalhador não cumpre os requisitos, por isso a entrada tem de ser registada como exceção.",
    "PERSON_NOT_BOUND": "Esta pessoa ainda não tem conta na aplicação.",
    "PERSON_NO_PROJECT_ACCESS": "A pessoa digitalizada não tem acesso a este projeto",
    "PERSON_ALREADY_CHECKED_IN": "A pessoa digitalizada já está registada neste projeto",
    "SUBJECT_NOT_FOUND": "A conta da pessoa digitalizada não foi encontrada",
    "SUBJECT_NOT_CHECKED_IN": "Este trabalhador não iniciou presença neste projeto, por isso não pode ser admitido aqui"
  },
  "QRCODE_SCANNER": {
    "TITLE": "A digitalizar",
    "SCAN_QR_CODE": "Digitalizar código QR",
    "RETRY_SCAN_QR_CODE": "Digitalizar código QR novamente",
    "CAMERA_PERMISSION_DENIED_EXPLANATION": "Abra as definições e dê permissão para usar a câmara",
    "OPEN_SETTINGS": "Abrir definições",
    "SCAN_AGAIN": "Digitalizar seguinte",
    "VERIFY_AGAINST": "Verificar para o projeto",
    "VERIFY_AGAINST_PLACEHOLDER": "Escolher um projeto"
  },
  "SELECT": {
    "DEFAULT_TITLE": "Selecione uma opção",
    "DEFAULT_MULTISELECT_TITLE": "Selecione uma ou mais opções"
  },
  "ONBOARDING": {
    "LOG_IN": "Entrar",
    "WELCOME_MESSAGE": "Bem-vindo à plataforma de aprendizagem e desenvolvimento."
  },
  "YIVI_REGISTRATION": {
    "TITLE": "Complete a sua conta",
    "DESCRIPTION": "Recebemos os seus dados de identidade da Yivi. Complete as informações restantes do iLOP para continuar.",
    "BIRTH_DATE": "Data de nascimento",
    "GENDER": "Género",
    "SUBMIT": "Criar conta",
    "CANCEL": "Cancelar"
  },
  "GENDER": {
    "MALE": "Masculino",
    "FEMALE": "Feminino",
    "OTHER": "Outro"
  },
  "SAVED_WORK": {
    "BUTTON_TITLE": "Guardado"
  },
  "NOTIFICATION": {
    "DISMISS": "Fechar"
  },
  "PROFILE": {
    "PERSONAL_INFORMATION": "Informação pessoal",
    "NAME": "Primeiro nome",
    "SURNAME": "Último nome",
    "NICKNAME": "Nome preferido",
    "NICKNAME_PLACEHOLDER": "Introduza o seu nome preferido (opcional)",
    "CERTIFICATES": "Certificados",
    "SAVE": "Guardar",
    "SELECT_FUNCTION": "Selecionar função",
    "LOGOUT": "Sair",
    "TOAST": {
      "SAVED": "A informação pessoal foi guardada",
      "ERROR": "Ocorreu um erro ao guardar a informação pessoal"
    },
    "AVATAR": {
      "ACTION_SHEET_TITLE": "O que quer fazer?",
      "CHANGE_LABEL": "Alterar foto de perfil",
      "DELETE_LABEL": "Eliminar foto de perfil",
      "CANCEL_LABEL": "Cancelar",
      "RESIZE_ERROR": "Não foi possível processar a fotografia. Tente outra fotografia.",
      "CROP_TITLE": "Recortar foto",
      "CROP_CONFIRM": "Usar foto",
      "CROP_ZOOM_LABEL": "Ampliação"
    },
    "SETTINGS": "Definições",
    "SETTINGS_ROUTES": {
      "CHANGE_PASSWORD": "Alterar palavra-passe"
    },
    "PASSWORD": {
      "LABEL_CURRENT": "Palavra-passe atual",
      "PLACEHOLDER_CURRENT": "Introduza a sua palavra-passe atual",
      "LABEL_NEW": "Nova palavra-passe",
      "PLACEHOLDER_NEW": "Introduza a sua nova palavra-passe",
      "LABEL_VERIFY_NEW": "Verificar nova palavra-passe",
      "PLACEHOLDER_VERIFY_NEW": "Introduza novamente a sua nova palavra-passe",
      "BUTTON_LABEL": "Alterar palavra-passe",
      "TOAST": {
        "SUCCESS": "A palavra-passe foi alterada. Entre novamente com a sua nova palavra-passe",
        "ERROR": "Ocorreu um erro ao alterar a palavra-passe"
      },
      "FORM_VALIDATION_MISMATCH": "As novas palavras-passe não coincidem"
    }
  },
  "PROJECT_DETAILS": {
    "TITLE": "Detalhes do projeto",
    "SWI_SIGNED": "SWI assinada",
    "SWI_OPEN": "SWI pendente",
    "SWI_SIGNED_COUNT": "{count} SWI assinadas",
    "SWI_SIGNED_OF": "{signed} de {total} SWI assinadas",
    "REPORT_SAFETY_RISKS": "Reportar riscos de segurança",
    "SEE_SAFETY_REPORTS": "Abrir relatórios de segurança",
    "CONTRACTOR": "Subcontratado",
    "CLIENT": "Cliente",
    "SELECT": "Selecionar",
    "WORKERS": "Trabalhadores",
    "DESELECT": "Desselecionar",
    "WORKERS_EMPTY_STATE": "Ainda não há trabalhadores registados neste projeto.",
    "UNKNOWN_EMPLOYER": "Empregador desconhecido",
    "CERTIFICATES": "Certificados de projeto obrigatórios",
    "TOOLBOXES": "Toolboxes de projeto obrigatórias",
    "TOOLBOXES_ALL_COMPLETED": "Todas as toolboxes obrigatórias estão concluídas",
    "ALERTS": "Mensagens",
    "CREATE_ALERT": "Adicionar mensagem",
    "ALERTS_EMPTY_STATE": "Atualmente não há mensagens para este projeto",
    "MAIN_OFFICE": "Sede",
    "CHECK_IN": "Registar entrada",
    "CHECK_OUT": "Registar saída",
    "AT_WORK": "{count} no trabalho",
    "REQUIREMENTS_CHECKLIST": "Requisitos do projeto",
    "OVERWRITE_CHECKIN_TITLE": "Registar entrada",
    "OVERWRITE_CHECKIN_MESSAGE": "Está atualmente registado em \"{projectName}\". Registar a entrada aqui termina esse registo.",
    "OVERWRITE_CHECKIN_CONFIRM": "Registar entrada",
    "OVERWRITE_CHECKIN_CANCEL": "Cancelar"
  },
  "PROJECT_SELECT": {
    "TITLE": "Selecionar projeto",
    "PROJECT_NAME": "Nome do projeto",
    "PROJECT_FUNCTION": "Função no projeto",
    "SELECT_AT_LEAST_ONE_FUNCTION": "Selecione pelo menos uma função.",
    "EMPLOYEE": "Funcionário",
    "NEXT": "Seguinte",
    "ALREADY_CHECKED_IN_TITLE": "Já registado",
    "ALREADY_CHECKED_IN_MESSAGE": "Já está registado neste projeto. Não precisa de fazer nada.",
    "INVALID_CODE": "Este código de projeto já não é válido. Peça ao encarregado o código atual.",
    "REPORT_TO_FOREMAN_TITLE": "Apresente-se ao encarregado",
    "REPORT_TO_FOREMAN_MESSAGE": "Está registado, mas não consta deste projeto. Apresente-se imediatamente ao encarregado."
  },
  "PROJECT_SELECT_CONFIRM": {
    "ALL_FULFILLED": "Todos os requisitos estão cumpridos",
    "BUTTON": "Confirmar",
    "TITLE": "Confirmar seleção de projeto"
  },
  "PROJECT_SELECT_SUCCESS": {
    "SUCCESS": "Sucesso!",
    "SELECTED": "Inscreveu-se no projeto.",
    "DESELECTED": "Cancelou a inscrição no projeto.",
    "BUTTON": "Início"
  },
  "CERTIFICATE": {
    "EXPIRED": "Expirou em {date}",
    "VALID_UNTIL": "Válido até {date}",
    "EXPIRES_IN": "Expira em {duration}",
    "EXPIRES_SOON": "Expira dentro de 3 meses",
    "EXPIRES_NEVER": "Nunca expira",
    "MISSING": "Ainda não obtido",
    "PENDING": "Aguardando revisão",
    "REJECTED": "Rejeitado",
    "VIEW_DOCUMENT": "Documento",
    "VIEW_DOCUMENT_N": "Documento {n}",
    "REGISTERED_TO": "Registado em nome de {name}"
  },
  "DOCUMENT_INPUT": {
    "ADD": "Adicionar foto ou PDF",
    "TAKE_PHOTO": "Tirar foto",
    "CHOOSE_FROM_LIBRARY": "Escolher da biblioteca",
    "CHOOSE_PDF": "Escolher PDF",
    "REMOVE": "Remover",
    "CANCEL": "Cancelar"
  },
  "ADD_CERTIFICATE": {
    "TITLE": "Adicionar certificado",
    "CERTIFICATE": "Certificado",
    "CERTIFICATE_NUMBER": "Número de certificado",
    "ISSUED_ON": "Emitido em",
    "EXPIRES_ON": "Expira em",
    "DOCUMENT": "Documento",
    "MISSING_FIELDS": "Por favor, selecione uma organização e um certificado.",
    "ERROR": "Algo correu mal. Por favor, tente novamente.",
    "CHOOSER": {
      "IMPORT": "Importar do registo",
      "UPLOAD": "Carregar documento"
    }
  },
  "IMPORT_CERTIFICATE": {
    "TITLE": "Importar certificado",
    "LAST_NAME": "Último nome",
    "DATE_OF_BIRTH": "Data de nascimento",
    "REGISTRY": "Registo",
    "CERTIFICATE_NUMBER": "Número de certificado",
    "MISSING_FIELDS": "Por favor, preencha todos os campos.",
    "SUCCESS": "Certificado importado.",
    "STATUS": {
      "NOTFOUND": "Não foi encontrado nenhum certificado para estes dados.",
      "REGISTRYERROR": "Não foi possível contactar o registo neste momento. Por favor, tente novamente mais tarde."
    }
  },
  "CERTIFICATES": {
    "NO_CERTIFICATES": "Nenhum certificado encontrado",
    "EXPIRED_CERTIFICATES": "Alguns dos seus certificados expiraram. Renove-os para continuar a trabalhar."
  },
  "MARKDOWN_CONTENT": {
    "TERMS_AND_CONDITIONS": "Termos e condições",
    "PRIVACY_POLICY": "Política de privacidade",
    "APP_INFO": "Informação da aplicação",
    "AVG_STATEMENT": "Declaração RGPD"
  },
  "HUMANIZE_DURATION": {
    "MONTHS": "{count, plural, =1{mês} other{meses}}",
    "DAYS": "{count, plural, =1{dia} other{dias}}",
    "SOON": "em breve"
  },
  "PERSON": {
    "FIRST_NAME": "Primeiro nome",
    "LAST_NAME": "Último nome",
    "EMAIL": "Endereço de email",
    "FUNCTION": "Função"
  },
  "WORKER_PROFILE": {
    "FUNCTION": "Função",
    "PROJECT": "Projeto atual",
    "CERTIFICATES": "Certificados",
    "PROJECT_DETAILS": "Detalhes do projeto",
    "UPDATE_PERSON_ACTION": "Editar detalhes",
    "ASSIGN_TO_PROJECT_ACTION": "Atribuir ao meu projeto"
  },
  "PHOTOS": {
    "PROFILE_PHOTO": "Escolher uma foto de perfil",
    "CANCEL": "Cancelar",
    "TAKE_PHOTO": "Tirar uma foto",
    "CHOOSE_FROM_LIBRARY": "Escolher da biblioteca"
  },
  "UMA": {
    "MY_REPORTS": {
      "TITLE": "Os meus relatórios",
      "EMPTY_STATE_TITLE": "Sem relatórios",
      "EMPTY_STATE_MESSAGE": "Os riscos de segurança que reportou aparecerão aqui.",
      "CREATE_REPORT": "Criar um relatório"
    },
    "REPORT": {
      "ASSIGNED_TO": "A ser tratado por {name}",
      "REPORTED_BY": "Reportado por {name}",
      "REPORTED_BY_ANONYMOUS": "Reportado anonimamente"
    },
    "PROJECT_REPORTS": {
      "TITLE": "Relatórios para {projectName}",
      "EMPTY_STATE_TITLE": "Sem relatórios",
      "EMPTY_STATE_MESSAGE": "Os riscos de segurança reportados neste projeto aparecerão aqui."
    },
    "CANNOT_CREATE_REPORT": {
      "TITLE": "Não é possível criar relatório",
      "DESCRIPTION": "Não está registado num projeto. Registe-se para poder criar um relatório."
    },
    "NEW_REPORT": {
      "CREATE_NEW_REPORT": "Criar relatório",
      "GENERAL": {
        "FORM_TITLE": "Geral",
        "CATEGORY": "O que gostaria de reportar?",
        "IS_SOLVED": "Está resolvido?",
        "IS_URGENT": "Urgência",
        "IS_ANONYMOUS": "Reportar anonimamente",
        "PROJECT": "Em que projeto gostaria de fazer este relatório?",
        "NO_PROJECTS": "Não está registado num projeto. Registe-se para poder criar um relatório.",
        "CHOOSE_PROJECT": "Escolher um projeto",
        "CONFIRM_PROJECT": "Não está registado neste projeto. Tem certeza de que quer fazer este relatório?",
        "CONFIRM_PROJECT_BUTTON": "Sim, tenho certeza",
        "VICTIMS": "Vítimas?",
        "ABSENTEEISM": "Absenteísmo",
        "HOSPITALISED": "Hospitalizados?",
        "HOSPITALISED_WARNING": {
          "BEFORE_PHONE": "EM CASO DE UM ACIDENTE GRAVE OU LESÃO QUE REQUEIRA HOSPITALIZAÇÃO, LIGUE SEMPRE PRIMEIRO PARA OS SERVIÇOS DE EMERGÊNCIA",
          "BETWEEN_PHONE_AND_URL": "OU VIA O FORMULÁRIO ONLINE:",
          "AFTER_LINK": "Consulte o seu supervisor, o capataz ou o coordenador de V&G responsável por este relatório."
        }
      },
      "SITUATION": {
        "FORM_TITLE": "Situação",
        "PHOTOS": "Como é que a situação se apresenta?",
        "PHOTOS_PLACEHOLDER": "Adicione uma ou mais fotos, ou preencha uma descrição",
        "DESCRIPTION": "Descrever a situação",
        "SAFE_SITUATION_DESCRIPTION": "Situação segura",
        "RISK": "Risco",
        "DESCRIPTION_OF_SITUATION": "Descrição da situação",
        "ACTIONS_TAKEN": "Ações tomadas",
        "RISK_CATEGORY": {
          "LABEL": "Categoria de risco",
          "PLACEHOLDER": "Escolher uma categoria",
          "REQUIRED": "A categoria é obrigatória"
        }
      },
      "SUMMARY": {
        "TITLE": "Relatório submetido",
        "MESSAGE": "O relatório com o número #{{id}} foi submetido."
      },
      "SEND": "Submeter",
      "SUCCESS_TOAST": "Relatório de segurança criado com sucesso",
      "VALIDATION": {
        "MISSING_FIELDS": "Por favor, preencha todos os campos obrigatórios"
      }
    },
    "REPORT_DETAILS": {
      "NOT_ASSIGNED_TO": "Não atribuído a um funcionário",
      "ASSIGNED_TO_PERSON": "Atribuído ao funcionário",
      "ASSIGN_TO_PERSON_PLACEHOLDER": "Atribuir ao funcionário",
      "DETAILS": "Detalhes",
      "TITLE": "Ver relatório {reportId}",
      "PROJECT_NAME": "Projeto",
      "REPORTER": "Relator",
      "ANONYMOUS_REPORTER": "Relator anónimo",
      "UNKNOWN_AUTHOR": "Autor desconhecido",
      "CATEGORY": "Tipo de relatório",
      "URGENCY": "Urgência",
      "SOLVED": "Resolvido",
      "PHOTOS": "Fotos",
      "PHOTOS_EMPTY": "Este relatório não contém fotos",
      "DESCRIPTION": "Descrição",
      "RISK": "Risco",
      "CREATED_AT": "Criado em",
      "CREATE_COMMENT": "Publicar comentário",
      "COMMENTS": "Comentários",
      "COMMENTS_EMPTY": "Ainda não foram publicados comentários",
      "COMMENT_BY": "Comentário de {person}",
      "COMMENT_CREATED": "Comentário publicado com sucesso",
      "LOGS": "Registos",
      "LOGS_EMPTY": "Ainda não há registos",
      "LOG": {
        "CREATED": "Relatório criado por {actor}",
        "STATUS_CHANGED": "Estado alterado para {newStatus} por {actor}",
        "COMMENTED": "Comentário publicado por {actor}"
      },
      "NOT_IN_PROJECT": "O relator não estava registado neste projeto"
    }
  },
  "PUSH_NOTIFICATIONS": {
    "CLOSE": "Fechar",
    "OPEN": "Abrir"
  },
  "REPORT_CATEGORY": {
    "ACCIDENT": "Acidente",
    "UNSAFE_SITUATION": "Inseguro",
    "SAFE_SITUATION": "Seguro"
  },
  "REPORT_STATUS": {
    "NEW": "Não lido",
    "IN_PROGRESS": "Em progresso",
    "SOLVED": "Resolvido",
    "ON_HOLD": "Pausado"
  },
  "NOTIFICATIONS": {
    "TITLE": "Notificações",
    "EMPTY_STATE_TITLE": "Sem notificações",
    "EMPTY_STATE_MESSAGE": "Encontrará aqui todas as notificações importantes do presente e passado",
    "NOTIFICATION_SENT_AT_FORMAT": "d MMMM HH:mm",
    "MARK_AS_READ": "Marcar como lida",
    "MARK_ALL_AS_READ": "Marcar todas como lidas",
    "MARK_ALL_AS_READ_SUCCESS": "Todas as notificações marcadas como lidas",
    "DELETE": "Eliminar",
    "DELETE_SUCCESS": "Notificação eliminada"
  },
  "REPORT_TRANSITION": {
    "NEW": "Voltar ao novo",
    "IN_PROGRESS": "Tomar em progresso",
    "SOLVED": "Marcar como resolvido",
    "ON_HOLD": "Pausar",
    "SOLVED_CONFIRMATION_TITLE": "Marcar relatório como resolvido?",
    "SOLVED_CONFIRMATION_MESSAGE": "Tem certeza de que deseja marcar este relatório como resolvido?"
  },
  "SPEECH_RECOGNITION": {
    "TITLE": "Fale o seu texto",
    "BTN_LABEL": "Falar texto",
    "PERMISSION_ERROR": "Não é possível falar texto. Sem permissão dada. Abra as definições do seu telefone e dê permissão para falar texto para esta aplicação.",
    "LISTENING": "A ouvir...",
    "USE_RESULT": "Introduzir resultado"
  },
  "CERTIFICATE_LIST": {
    "MY_EMPTY_STATE": "Ainda não obteve nenhum certificado",
    "PERSON_EMPTY_STATE": "Este funcionário ainda não obteve nenhum certificado",
    "PROJECT_EMPTY_STATE": "Não há certificados relevantes para este projeto",
    "PERSON_PROJECT_EMPTY_STATE": "Não há certificados relevantes para este funcionário neste projeto"
  },
  "ALERT_CATEGORY": {
    "GENERAL": "Geral",
    "WEATHER": "Tempo",
    "LOGISTIC": "Logística",
    "SAFETY": "Segurança"
  },
  "ALERT_DETAILS": {
    "EDIT": "Editar",
    "TITLE": "Detalhes da mensagem",
    "CONFIRM": "Compreendido",
    "DELETE_TITLE": "Eliminar mensagem",
    "DELETE_MESSAGE": "Tem certeza de que deseja eliminar esta mensagem?",
    "DELETE_CONFIRM": "Eliminar",
    "DELETE_SUCCESS": "Mensagem eliminada"
  },
  "ALERT_PLAYER": {
    "PLAY": "Reproduzir",
    "PAUSE": "Pausar",
    "LANGUAGE": "Idioma",
    "SEEK": "Progresso",
    "FULLSCREEN": "Ecrã inteiro"
  },
  "ALERT": {
    "CATEGORY": "Categoria",
    "TITLE": "Título",
    "DESCRIPTION": "Descrição",
    "VALID_FROM": "De",
    "VALID_UNTIL": "Até",
    "FROM": "de",
    "UNTIL": "até",
    "VIDEO": "Vídeo",
    "REMOVE_VIDEO": "Remover vídeo",
    "TYPE": "Tipo de mensagem",
    "TYPE_TEXT": "Texto",
    "TYPE_VIDEO": "Vídeo",
    "ADD_TARGET_AUDIENCE": "Adicionar público-alvo",
    "TARGET_AUDIENCE": "Público-alvo",
    "TARGET_AUDIENCE_EVERYONE": "Todos",
    "TARGET_AUDIENCE_MANAGEMENT": "Gestão",
    "SELECT_TARGET_AUDIENCE": "Selecionar público-alvo",
    "NO_FILE_SELECTED": "Nenhum ficheiro selecionado",
    "CHOOSE_FILE": "Escolher ficheiro",
    "TRANSLATION": "Tradução",
    "TRANSLATION_DESCRIPTION": "Traduzir este vídeo",
    "VIDEO_UPLOAD_FAILED": "O upload do vídeo falhou",
    "AUDIENCE": {
      "MANAGEMENT": "Direção",
      "ORGANISATION": "Organização:",
      "FUNCTION": "Função:",
      "FUNCTION_GROUP": "Grupo de funções:",
      "ADD_MANAGEMENT": "Direção",
      "ADD_ORGANISATION": "Organização",
      "ADD_FUNCTION": "Função ou grupo",
      "SELECT_ORGANISATION": "Escolha uma organização",
      "NO_ORGANISATIONS": "Nenhuma organização neste projeto.",
      "LOADING_ORGANISATIONS": "A carregar..."
    }
  },
  "NEW_ALERT": {
    "TITLE": "Adicionar mensagem",
    "ACTION": "Criar mensagem",
    "SUCCESS_TOAST_MESSAGE": "Mensagem criada com sucesso"
  },
  "EDIT_ALERT": {
    "TITLE": "Editar mensagem",
    "ACTION": "Guardar alterações",
    "SUCCESS_TOAST_MESSAGE": "Mensagem atualizada com sucesso"
  },
  "EDIT_PERSON_PROJECT": {
    "TITLE": "Atribuir projeto",
    "SUCCESS_TOAST_MESSAGE": "Atribuição de projeto atualizada com sucesso"
  },
  "REASSIGN_PERSON_PROJECT": {
    "TITLE": "Atribuir projeto",
    "SUCCESS_TOAST_MESSAGE": "Atribuição de projeto bem-sucedida"
  },
  "SELECT_UI": {
    "SEARCHBAR_PLACEHOLDER": "Procurar uma opção"
  },
  "CHECKLIST": {
    "COMPLETED": "Lista de verificação concluída com sucesso",
    "ERROR": "Algo correu mal ao concluir a lista de verificação",
    "LIST_LABEL": "Listas de verificação",
    "ALL_COMPLETED": "Todas as listas de verificação obrigatórias estão concluídas",
    "COMPLETE": "Concluir"
  },
  "PASSWORD_COMPLEXITY": {
    "REQUIREMENTS": "Requisitos de palavra-passe:",
    "MIN_LENGTH": "Pelo menos {minLength} caracteres",
    "UPPERCASE": "Pelo menos uma letra maiúscula",
    "LOWERCASE": "Pelo menos uma letra minúscula",
    "DIGIT": "Pelo menos um número",
    "SPECIAL_CHAR": "Pelo menos um carácter especial"
  },
  "FUNCTION_SELECT": {
    "ROOT": "Raiz",
    "SEARCH_PLACEHOLDER": "Procurar uma função",
    "NO_RESULTS": "Nenhuma função encontrada",
    "WHOLE_CATEGORY": "Grupo completo: {name}"
  },
  "WORKER_DETAIL": {
    "START_WORK_INSTRUCTION": "Start Werk Instructie",
    "SWI_SIGNED_ON": "Assinada em {moment}",
    "NO_SWI_SIGNATURE": "Ainda não assinada",
    "SWI_SIGNATURE_ALT": "Assinatura",
    "SWI_SIGNATURE_FAILED": "Não foi possível carregar a assinatura",
    "TITLE": "Detalhes do trabalhador",
    "ITEM_STATUS": {
      "PRESENT": "Presente",
      "MISSING": "Em falta",
      "EXPIRED": "Expirado",
      "EXPIRED_GRACE_PERIOD": "Expirado (período de tolerância)"
    },
    "CERTIFICATES": "Certificados",
    "CHECKLISTS": "Listas de verificação",
    "SAFETY_INSTRUCTIONS": "Instruções de Segurança",
    "TOOLBOXES": "Caixas de ferramentas",
    "NAME": "Nome",
    "VERIFIED_AGAINST": "Verificado para {project}",
    "BASIC_INFORMATION": "Informações básicas",
    "ILOP_CONTENT": "Conteúdo i-LOP",
    "NO_EMPLOYMENTS": "Este trabalhador não tem vínculos ativos",
    "NO_ILOP_CONTENT": "Não existe conteúdo i-LOP relevante para este trabalhador neste projeto",
    "CHECK_IN": {
      "SINCE": "Check-in às"
    },
    "EMPLOYMENT": {
      "FUNCTION": "Função",
      "FROM": "De",
      "TO": "Até"
    },
    "CERTIFICATE": {
      "NUMBER": "Número",
      "ISSUED_ON": "Emitido em",
      "ISSUED_FOR": "Emitido para",
      "EXPIRES_ON": "Expira em"
    },
    "CONTENT": {
      "COMPLETED_ON": "Concluído em",
      "MEETING_ENDED": "Reunião terminada",
      "SIGNED": "Assinado"
    },
    "KVK": {
      "NUMBER": "Número KvK",
      "DOCUMENT_DATE": "Extrato datado de",
      "VALID_UNTIL": "Válido até",
      "DOCUMENT": "Extrato KvK"
    },
    "OPEN_DOCUMENT": "Abrir",
    "OPEN_DOCUMENT_FAILED": "Não foi possível abrir o documento"
  },
  "GATE_ENTRY": {
    "TITLE": "Registar entrada",
    "GAPS_HINT": "Este trabalhador não cumpre os requisitos, por isso deixá-lo entrar é uma exceção.",
    "NOT_CHECKED_IN_HINT": "Este trabalhador não iniciou presença neste projeto. Inicie a presença para o admitir ou recuse a entrada.",
    "CHECK_IN_WORKER": "Iniciar presença do trabalhador",
    "DECISION": {
      "VALID": "Válida",
      "EXCEPTION": "Exceção",
      "DENIED": "Recusada"
    },
    "REASON": {
      "HEADER_EXCEPTION": "Motivo da exceção",
      "HEADER_DENIED": "Motivo da recusa de entrada",
      "MESSAGE": "Isto é registado com o seu nome e a hora.",
      "PLACEHOLDER": "Descreva o motivo",
      "CONFIRM": "Registar"
    },
    "REGISTERED": "Entrada registada"
  },
  "EMPLOYMENT": {
    "TIMELINE": {
      "TITLE": "Histórico de Emprego",
      "NO_EMPLOYMENTS": "Nenhum histórico de emprego disponível.",
      "PRESENT": "Presente",
      "ACTIVE": "Ativo",
      "NOT_YET_ACTIVE": "Ainda não ativo",
      "LOAD_ERROR": "Ocorreu um erro ao carregar o histórico de emprego.",
      "STATUS_FOR_ADMIN_REVIEW": "Em revisão",
      "STATUS_FOR_USER_REVIEW": "Verifique seu emprego",
      "ADD_EMPLOYMENT": "Adicionar",
      "REVIEW_NOTICE": "Existem empregos aguardando sua revisão.",
      "REVIEW_NOTICE_ACTION": "Toque para visualizar e revisar.",
      "REVIEW_OPEN": "Rever",
      "REVIEW_DETAILS_TITLE": "Revisar emprego",
      "FUNCTION": "Função",
      "START_DATE": "Data de início",
      "END_DATE": "Data de término",
      "MANAGERIAL": "Gerencial",
      "YES": "Sim",
      "NO": "Não",
      "ACCEPT": "Aceitar",
      "REJECT": "Rejeitar",
      "REVIEW_ACCEPT_SUCCESS": "Emprego aceito com sucesso.",
      "REVIEW_REJECT_SUCCESS": "Emprego rejeitado com sucesso.",
      "REVIEW_ERROR": "Ocorreu um erro ao revisar o emprego."
    },
    "DETAIL": {
      "TITLE": "Vínculo laboral",
      "NOT_FOUND": "Não foi possível encontrar este vínculo laboral."
    },
    "CREATE": {
      "TITLE": "Adicionar emprego",
      "ORGANISATION": "Organização",
      "SEARCH_ORGANISATION": "Procurar organização",
      "NO_ORGANISATIONS": "Nenhuma organização encontrada.",
      "FUNCTION": "Função",
      "START_DATE": "Data de início",
      "END_DATE": "Data de término",
      "MANAGERIAL_LABEL": "Função gerencial",
      "BUSINESS_REGISTRY_NUMBER": "Número de registro comercial",
      "SAVE": "Salvar",
      "SAVE_SUCCESS": "Emprego adicionado com sucesso.",
      "SAVE_ERROR": "Ocorreu um erro ao adicionar o emprego.",
      "LOAD_ORGANISATIONS_ERROR": "Ocorreu um erro ao carregar as organizações.",
      "END_DATE_BEFORE_START": "A data de término não pode ser anterior à data de início.",
      "ORGANISATION_UNAVAILABLE": "Esse empregador não está mais disponível. Escolha outro.",
      "FUNCTION_UNKNOWN": "Essa função não está mais disponível. Escolha outra.",
      "BINDING_CONFLICT": "Este empregador já conhece alguém com o seu endereço de email, em outra conta. Peça a ele que convide você.",
      "IDENTITY_INCOMPLETE": "Sua conta não tem o seu nome ou endereço de email, então um empregador ainda não pode registrar você. Entre com o Yivi para completá-la.",
      "REQUEST_ALREADY_PENDING": "Você já tem uma solicitação pendente neste empregador. Aguarde a resposta dele.",
      "INVITATION_PENDING": "Este empregador já convidou você. Aceite ou rejeite esse convite no seu histórico de emprego."
    }
  },
  "TOOLBOXES": {
    "TABS": {
      "LIST": "Lista",
      "REGISTRATION": "Registo"
    },
    "EMPTY_STATE": "Nenhum toolbox disponível",
    "LAST_UPDATED": "Atualizado",
    "VIEW_DOCUMENT": "Ver documento",
    "ASYNC": {
      "COMPLETED": "Toolbox concluído",
      "ERROR_COMPLETING": "Falha ao concluir o toolbox"
    },
    "FOLLOWED": {
      "TITLE": "Toolboxes concluídos",
      "LINK": "Ver toolboxes concluídos",
      "FILTER_CATEGORY": "Categoria",
      "FILTER_TYPE": "Tipo",
      "TYPE_SYNCHRONOUS": "Síncrono",
      "TYPE_ASYNCHRONOUS": "Assíncrono",
      "TYPE_MANUAL": "Manual",
      "NOT_AVAILABLE": "Já não está disponível",
      "EMPTY_STATE": "Ainda não concluiu nenhum toolbox",
      "EMPTY_FILTERED": "Nenhum toolbox concluído corresponde a estes filtros"
    },
    "MEETING": {
      "HOST_MEETING": "Iniciar reunião toolbox",
      "START_ANOTHER_TITLE": "Iniciar outra reunião?",
      "START_ANOTHER_MESSAGE": "Já tem {count, plural, =1{uma reunião toolbox} other{# reuniões toolbox}} a decorrer. Iniciar outra?",
      "START_ANOTHER_CONFIRM": "Iniciar outra",
      "ONLY_MANAGERIAL_CAN_HOST": "Apenas gestores podem organizar uma reunião toolbox",
      "ONLY_MANAGERIAL_CAN_MANAGE": "Apenas gestores podem gerir uma reunião toolbox",
      "VIEW_ACTIVE_MEETING": "Ver reunião ativa",
      "SELECT_ACTIVE_MEETING": "Selecione uma reunião",
      "MANUAL": {
        "START_BUTTON": "Iniciar reunião manual",
        "DESCRIPTION": "Inicie uma nova reunião manual de toolbox para a sua equipa como gestor.",
        "START_TITLE": "Iniciar reunião manual",
        "ORGANISATION": "Organização",
        "ORGANISATION_PLACEHOLDER": "Selecione uma organização",
        "TITLE": "Título",
        "TITLE_PLACEHOLDER": "Introduza um título",
        "DESCRIPTION_PLACEHOLDER": "Descrição opcional",
        "START_MISSING_FIELDS": "Por favor, preencha todos os campos obrigatórios",
        "TITLE_REQUIRED": "O título é obrigatório",
        "TITLE_NOT_ALLOWED": "O título só pode ser alterado em reuniões manuais",
        "END_BEFORE_START": "A hora de fim não pode ser anterior à hora de início",
        "ACTIVE_LIST_TITLE": "As suas reuniões toolbox",
        "ACTIVE_BADGE": "Em curso",
        "PLANNED_BADGE": "Agendada",
        "CONTINUE_BUTTON": "Continuar esta reunião"
      },
      "TITLE": "Reunião toolbox",
      "PARTICIPANTS": "Participantes",
      "NO_PARTICIPANTS": "Ainda sem participantes",
      "EXTERNAL_PARTICIPANT": "externo",
      "INFORMATION": "Informação",
      "START_DATE": "Data de início",
      "END_DATE": "Data de fim",
      "DESCRIPTION": "Descrição",
      "FINISH_MEETING": "Terminar reunião",
      "EDIT_MEETING": "Editar reunião",
      "SAVE": "Guardar",
      "CANCEL": "Cancelar",
      "FINISH_CONFIRMATION_TITLE": "Terminar reunião?",
      "FINISH_CONFIRMATION_MESSAGE": "Tem a certeza de que pretende terminar esta reunião toolbox?",
      "MEETING_ENDED_TITLE": "Reunião terminada",
      "MEETING_ENDED_MESSAGE": "Esta reunião foi terminada em {endTime} por {finishedByName}",
      "MEETING_ALREADY_STARTED": "Uma reunião já foi iniciada por outra pessoa",
      "ERROR_POLLING_MEETING": "Ocorreu um erro ao verificar reuniões",
      "ERROR_STARTING_MEETING": "Falha ao iniciar a reunião",
      "ERROR_LOADING_MEETING": "Falha ao carregar a reunião",
      "ERROR_UPDATING_MEETING": "Falha ao atualizar a reunião",
      "ERROR_FINISHING_MEETING": "Falha ao terminar a reunião",
      "ERROR_END_BEFORE_START": "A hora de fim não pode ser anterior à hora de início",
      "SCAN_QR_CODE": "Escanear código QR",
      "RETRY_SCAN": "Tentar novamente",
      "SCAN_TO_JOIN": "Escanear para participar",
      "JOIN_TOOLBOX_MEETING": "Participar da reunião de toolbox",
      "JOIN_DESCRIPTION": "Participe de uma reunião de toolbox existente digitalizando um código QR ou inserindo um código de reunião.",
      "QR_SCAN_WRONG_MEETING": "Este código QR é para uma reunião diferente",
      "QR_SCAN_ALREADY_PARTICIPANT": "Você já é participante desta reunião",
      "QR_SCAN_INVALID": "Formato de código QR inválido",
      "QR_SCAN_ERROR": "Ocorreu um erro ao escanear",
      "QR_SCAN_NO_PERMISSION": "É necessária permissão da câmera para escanear códigos QR",
      "SUCCESSFULLY_JOINED": "Participou com sucesso da reunião",
      "ADD_PARTICIPANT": {
        "TITLE": "Adicionar participante",
        "CHOOSE_METHOD": "Escolha como deseja adicionar um participante a esta reunião toolbox: escaneie o código QR do i-LOP ou insira manualmente um nome",
        "SCAN_QR_CODE": "Escanear código QR",
        "MANUAL": "Manual",
        "MANUAL_ENTRY": "Entrada manual",
        "OR": "ou",
        "FIRST_NAME": "Primeiro nome",
        "LAST_NAME": "Último nome",
        "FIRST_NAME_PLACEHOLDER": "Insira o primeiro nome",
        "LAST_NAME_PLACEHOLDER": "Insira o último nome",
        "CONFIRM": "Confirmar",
        "ADDING": "Adicionando...",
        "SUCCESS": "Participante adicionado com sucesso",
        "ERROR": "Falha ao adicionar participante",
        "MEETING_NOT_FOUND": "Reunião não encontrada",
        "ALREADY_PARTICIPANT": "Esta pessoa já é participante da reunião",
        "MEETING_INACTIVE": "A reunião não está ativa",
        "QR_VERIFY_PERMISSION_ERROR": "Não tem permissão para verificar este código QR. Use a entrada manual em vez disso.",
        "MISSING_PARAMETERS": "Parâmetros obrigatórios em falta para navegação",
        "NAVIGATION_ERROR": "Falha ao navegar para a página de adicionar participante",
        "PERSON_NOT_IN_ORGANISATION": "A pessoa digitalizada não pertence à sua organização",
        "PERSON_NOT_BOUND": "Esta pessoa ainda não tem uma conta na aplicação. Adicione-a como participante externo.",
        "PERSON_BINDING_CONFLICT": "Esta pessoa está associada a várias contas na aplicação e não pode ser adicionada. Contacte o seu administrador.",
        "NO_PERSON_RECORD": "Este trabalhador tem uma conta, mas ainda não está empregado numa organização, pelo que não pode ser adicionado como participante. Adicione-o como participante externo."
      }
    }
  },
  "SIGNATURE": {
    "TITLE": "Assinatura",
    "INSTRUCTIONS": "Por favor, assine abaixo",
    "CLEAR": "Limpar",
    "CONFIRM": "Confirmar"
  },
  "PERSON_CHECKIN_CARD": {
    "CHECKED_IN_AT": "Registado às:",
    "LAST_CHECKED_OUT_AT": "Última saída registada às:",
    "NOT_CHECKED_IN": "Não registado",
    "CERTIFICATES": "Certificados",
    "MORE_CERTIFICATES": "{count} mais",
    "ADD_CERTIFICATE": "Adicionar certificado"
  },
  "ZZP_COMPANY": {
    "TITLE": "Perfil da empresa (ZZP)",
    "INTRO": "Crie um perfil para a sua empresa em nome individual (ZZP).",
    "COMPANY_NAME": "Nome da empresa",
    "KVK_NUMBER": "Número da Câmara de Comércio (KvK)",
    "SAVE": "Guardar",
    "TOAST": {
      "SAVED": "O perfil da empresa foi guardado",
      "ERROR": "Ocorreu um erro ao guardar o perfil da empresa",
      "LOAD_ERROR": "Ocorreu um erro ao carregar o perfil da empresa"
    },
    "KVK_EXTRACT": {
      "LABEL": "Extrato KvK",
      "ADD": "Adicionar extrato KvK",
      "VIEW": "Ver extrato KvK",
      "REMOVE": "Remover",
      "UPLOADED": "O extrato KvK foi carregado",
      "REMOVED": "O extrato KvK foi removido",
      "INVALID_TYPE": "Apenas são permitidos ficheiros PDF ou de imagem",
      "DOCUMENT_DATE": "Data no extrato KvK",
      "VALID_UNTIL": "Válido até",
      "OUT_OF_DATE": "Este extrato KvK é demasiado antigo. Carregue um mais recente.",
      "NEEDS_DATE": "Introduza a data do extrato para que este seja considerado.",
      "NEEDS_DOCUMENT": "Carregue o extrato KvK para que a data seja considerada."
    }
  },
  "START_WORK_INSTRUCTION": {
    "NEW_TITLE": "Nova SWI",
    "STEP_OF": "Passo {step} de {total}",
    "NEXT": "Seguinte",
    "LOADING": "A carregar…",
    "SAVED": "Start Werk Instructie guardada",
    "STEP_LABEL": {
      "PERIOD": "Data ou período",
      "MESSAGES": "Mensagens: instruções de segurança de hoje",
      "INSTRUCTIONS": "Instruções",
      "TOOLBOXES": "Toolboxes",
      "CHECKLISTS": "Checklists",
      "SUMMARY": "Resumo",
      "NEW_MESSAGE": "Nova mensagem"
    },
    "PERIOD": {
      "SINGLE_DAY": "Um dia",
      "RANGE": "Período",
      "DATE": "Data",
      "FROM": "De",
      "UNTIL_INCLUSIVE": "Até inclusive",
      "ONE_PER_DAY_HINT": "Só pode estar ativa uma SWI por dia neste projeto.",
      "TAKEN_DAYS_HINT": "Os dias marcados já têm uma SWI e não podem ser escolhidos.",
      "OVERLAP": "Já existe uma Start Werk Instructie neste período. Escolha outras datas."
    },
    "CONTENT": {
      "MESSAGES_HEADING": "Mensagens",
      "MESSAGES_HINT": "Só são mostradas mensagens do tipo Segurança. Pode escolher várias.",
      "MESSAGES_EMPTY": "Sem mensagens de segurança atuais neste projeto.",
      "INSTRUCTIONS_HEADING": "Instruções",
      "INSTRUCTIONS_HINT": "Só é mostrado conteúdo marcado como utilizável numa SWI.",
      "INSTRUCTIONS_EMPTY": "Sem instruções disponíveis para uma SWI.",
      "TOOLBOXES_HEADING": "Toolboxes",
      "TOOLBOXES_HINT": "Só é mostrado conteúdo marcado como utilizável numa SWI.",
      "TOOLBOXES_EMPTY": "Sem toolboxes disponíveis para uma SWI.",
      "CHECKLISTS_HEADING": "Checklists",
      "CHECKLISTS_HINT": "Só é mostrado conteúdo marcado como utilizável numa SWI.",
      "CHECKLISTS_EMPTY": "Sem checklists disponíveis para uma SWI.",
      "MEDIUM_VIDEO": "Vídeo",
      "MEDIUM_DOCUMENT": "Para ler"
    },
    "SUMMARY": {
      "CHANGE": "Alterar",
      "NOTHING_SELECTED": "Nada selecionado",
      "NO_CONTENT": "Escolha pelo menos uma mensagem, instrução, toolbox ou checklist.",
      "SAVE": "Guardar",
      "PERIOD_SINGLE": "Start Werk Instructie de {date}",
      "PERIOD_RANGE": "Start Werk Instructie de {from} a {to}"
    },
    "REPEAT": {
      "HEADING": "Repetição",
      "FIRST_ENTRY": "Apenas na primeira entrada na obra",
      "EVERY_ENTRY": "Todas as vezes que entra na obra",
      "AFTER_ABSENCE": "Seguir novamente após uma ausência",
      "ABSENCE_DAYS": "Superior a (dias)",
      "ABSENCE_DAYS_RANGE": "Introduza um número entre {min} e {max}."
    },
    "EDIT_TITLE": "Editar SWI",
    "NEW_MESSAGE": {
      "ACTION": "Nova mensagem (texto ou vídeo)",
      "OR_PICK": "Ou escolha mensagens existentes",
      "HINT": "O período e a categoria são obtidos da Start Werk Instructie.",
      "ADD": "Adicionar mensagem",
      "SAVE": "Guardar mensagem",
      "REMOVE": "Remover mensagem"
    },
    "FOLLOW": {
      "TITLE": "Start Werk Instructie",
      "INTRO": "Conclua tudo o que está abaixo e depois assine.",
      "PROGRESS": "{done} de {total} concluídos",
      "EMPTY": "Hoje não há nada a seguir neste projeto.",
      "LOAD_FAILED": "Não foi possível carregar a Start Werk Instructie.",
      "RETRY": "Tentar novamente",
      "NEXT": "Passo seguinte",
      "SIGN_INTRO": "Confira os seus dados e assine.",
      "NAME": "Nome",
      "DATE": "Data",
      "COMPANY": "Empresa",
      "FUNCTION": "Função",
      "CLEAR": "Limpar",
      "SIGN_AND_FINISH": "Assinar e concluir",
      "SIGNED": "Start Werk Instructie assinada",
      "SIGN_FAILED": "A assinatura não foi concluída. Tente novamente."
    },
    "CARD": {
      "HEADING": "Start Werk Instructie ativa",
      "STATUS_ACTIVE": "Ativa",
      "STATUS_PLANNED": "Planeada",
      "PERIOD_RANGE": "{from} a {to}",
      "REPEAT_EVERY_ENTRY": "a cada entrada na obra",
      "REPEAT_FIRST_ENTRY": "apenas na primeira entrada"
    }
  }
}
